import React from 'react'
import { Breadcrumb, BreadcrumbItem } from '@/components/ui-compat'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faHome, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'

interface BreadcrumbFolder {
  id: string
  name: string
}

interface BreadcrumbsProps {
  path: BreadcrumbFolder[]
  onNavigate: (folderId: string | null) => void
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ path, onNavigate }) => {
  const { t } = useTranslation()

  return (
    <Breadcrumb
      className="mb-0 bg-transparent p-0"
      listClassName="mb-0 bg-transparent p-0 flex-nowrap"
      style={{ fontSize: '14px' }}
    >
      {/* Root / Home */}
      <BreadcrumbItem
        active={path.length === 0}
        style={{ cursor: path.length > 0 ? 'pointer' : 'default' }}
        onClick={() => path.length > 0 && onNavigate(null)}
      >
        <span className={path.length > 0 ? 'text-primary' : 'text-foreground font-medium'}>
          <Icon icon={faHome as any} className="mr-1" />
          {t('DocControl_root_folder')}
        </span>
      </BreadcrumbItem>

      {/* Path folders */}
      {path.map((folder, index) => {
        const isLast = index === path.length - 1
        return (
          <BreadcrumbItem
            key={folder.id}
            active={isLast}
            style={{ cursor: isLast ? 'default' : 'pointer' }}
            onClick={() => !isLast && onNavigate(folder.id)}
          >
            <span className={isLast ? 'text-foreground font-medium' : 'text-primary'}>
              {folder.name}
            </span>
          </BreadcrumbItem>
        )
      })}
    </Breadcrumb>
  )
}

export default Breadcrumbs
